import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { getToken, getUserStatus, hasPage, isTeamMember, firstAllowedPath } from '../api';

function ProtectedRoute({ children, adminOnly = false, ownerOnly = false, page = null }) {
  const location = useLocation();
  // No token → login. The axios 401/403 interceptors also handle live changes.
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  // Account not yet approved / suspended / expired → waiting page.
  if (getUserStatus() !== 'active') {
    return <Navigate to="/pending" replace />;
  }
  if (adminOnly && localStorage.getItem('userRole') !== 'admin') {
    return <Navigate to="/" replace />;
  }
  // Pages réservées au propriétaire (ex : gestion d'équipe).
  if (ownerOnly && isTeamMember()) {
    return <Navigate to={firstAllowedPath()} replace />;
  }
  // Membre d'équipe : page non autorisée → première page permise.
  if (page && isTeamMember() && !hasPage(page)) {
    const fallback = firstAllowedPath();
    if (fallback !== location.pathname) {
      return <Navigate to={fallback} replace />;
    }
    return (
      <Box sx={{ p: 6, textAlign: 'center' }}>
        <Typography sx={{ color: '#a1a1aa' }}>
          Aucune page ne t'a été autorisée. Contacte le propriétaire de l'équipe.
        </Typography>
      </Box>
    );
  }
  return children;
}

export default ProtectedRoute;
